/**
 * 리스크 등급 — factsheet 와 같은 6단계 (웨비나 「펀드 결산」 편 · 공개 데모, 2026-10-09).
 * 화면 상수만 둔다. 등급 값은 DB(`investment_risk_assessments.grade`) — 승인된 것만 지표에 쓴다.
 */
export const RISK_GRADES = ['성장', '기대', '관찰', '주의', '우려', '위험'] as const;
export type RiskGrade = (typeof RISK_GRADES)[number];
export const GRADE_RANK: Record<RiskGrade, number> = { '성장': 1, '기대': 2, '관찰': 3, '주의': 4, '우려': 5, '위험': 6 };

export const RISK_STYLE: Record<RiskGrade | '미평가', string> = {
  '성장': 'bg-emerald-50 text-emerald-700',
  '기대': 'bg-teal-50 text-teal-700',
  '관찰': 'bg-sky-50 text-sky-700',
  '주의': 'bg-amber-50 text-amber-700',
  '우려': 'bg-orange-50 text-orange-700',
  '위험': 'bg-red-50 text-red-600',
  '미평가': 'bg-slate-100 text-slate-500',
};

export const RISK_BAR: Record<RiskGrade | '미평가', string> = {
  '성장': 'bg-emerald-500', '기대': 'bg-teal-500', '관찰': 'bg-sky-500', '주의': 'bg-amber-500', '우려': 'bg-orange-500', '위험': 'bg-red-500', '미평가': 'bg-slate-300',
};
